export function getEndIndex(currentIndex: number, itemsPerPage: number, total: number): number {
    if ((currentIndex + itemsPerPage) > total) {
        return total;
    } else {
        return currentIndex + itemsPerPage;
    }
}

export function getNextStartingIndex(currentIndex: number, itemsPerPage: number): number {
    return currentIndex + itemsPerPage;
}

export function getPrevStartingIndex(currentIndex: number, itemsPerPage: number): number {
    return currentIndex - itemsPerPage;
}

